import { resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, vModelText as _vModelText, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = { class: "o-form__item" }
const _hoisted_3 = ["maxlength", "minlength", "id", "name", "placeholder", "required", "autocomplete"]
const _hoisted_4 = { class: "o-form__validation" }
const _hoisted_5 = { class: "o-form__validation__required" }
const _hoisted_6 = { class: "o-form__validation__error" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_inputlabel = _resolveComponent("inputlabel")

  return (!$props.disabledIDs.includes($props.field.id))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass((!$props.field.inputClass) ? 'o-grid-12' : $props.field.inputClass)
      }, [
        _createVNode(_component_inputlabel, { field: $props.field }, null, 8 /* PROPS */, ["field"]),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("textarea", _mergeProps({
            class: ["o-textarea", { 'readonly': $props.field.inputReadonly === true }]
          }, _toHandlers($data.readOnlyHandlers, true), {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($props.field.value) = $event)),
            maxlength: ($props.field.inputMaxlength && String($props.field.inputMaxlength).trim() != '') ? $props.field.inputMaxlength : null,
            minlength: ($props.field.inputMinlength && String($props.field.inputMinlength).trim() != '') ? $props.field.inputMinlength : null,
            id: 'input-'+$props.field.id,
            name: $props.field.inputName,
            placeholder: $props.field.inputPlaceholder,
            required: ($props.field.inputRequired === true) ? 'required' : false,
            autocomplete: ($props.field.inputAutocomplete && $props.field.inputAutocomplete != '' && $props.field.inputAutocomplete != 'querystring' && $props.field.inputAutocomplete != 'reactivevalue' && $props.field.inputAutocomplete != 'cookie') ? $props.field.inputAutocomplete : false
          }), "\n            ", 16 /* FULL_PROPS */, _hoisted_3), [
            [_vModelText, $props.field.value]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx._t('Ce champ est invalide.')), 1 /* TEXT */)
          ])
        ])
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}